import Modal from "@/components/base/Modal";
import Confetti from "./Confetti";
import type { LadderPrize } from "@/lib/types";

interface ResultModalProps {
  open: boolean;
  prize: LadderPrize | null;
  end?: number;
  onClose: () => void;
}

// 사다리 결과 모달 (당첨 → 색종이 + 경품명 크게, 꽝 → 담담하게)
export default function ResultModal({ open, prize, end, onClose }: ResultModalProps) {
  const win = prize?.is_win === 1;

  return (
    <Modal open={open} onClose={onClose} labelledBy="ladder-result-title">
      <div className="relative overflow-hidden p-8 text-center">
        {win && <Confetti />}

        <span
          className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${
            win ? "bg-accent-100 text-accent-700" : "bg-background-100 text-foreground-400"
          }`}
        >
          <i
            className={`${win ? "ri-gift-2-line" : "ri-emotion-normal-line"} text-3xl`}
            aria-hidden="true"
          ></i>
        </span>

        <h2
          id="ladder-result-title"
          className="mt-4 font-heading text-xl font-bold text-foreground-950"
        >
          {win ? "당첨을 축하합니다!" : "아쉽게도 꽝입니다"}
        </h2>

        {win ? (
          <>
            <p
              className="mt-3 font-heading text-3xl font-bold"
              style={{ color: prize?.color || "oklch(var(--primary-600))" }}
            >
              {prize?.name}
            </p>
            <p className="mt-2 text-sm text-foreground-600">
              경품은 클럽 총무를 통해 전달됩니다.
            </p>
          </>
        ) : (
          <p className="mt-2 text-sm text-foreground-600">
            다음 기회에 다시 도전해 보세요.
          </p>
        )}

        {end != null && (
          <p className="mt-4 text-xs text-foreground-400">{end + 1}번 칸에 도착</p>
        )}

        <button
          type="button"
          onClick={onClose}
          className={`mt-6 w-full whitespace-nowrap rounded-md px-5 py-3 text-sm font-bold transition-colors ${
            win
              ? "bg-secondary-500 text-primary-950 hover:bg-secondary-600"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
          }`}
        >
          확인
        </button>
      </div>
    </Modal>
  );
}